import { useMemo } from 'react';
import { Currency } from 'api/account';
import { FieldOptionBase } from 'api/tasks';
import { FieldType, SourceType } from 'components/organisms/tasks/fields';
import { useAccountCurrency } from 'hooks/use-account-currency';
import { useTranslation } from 'hooks/use-translation';
import { getCurrencyLabel } from 'utils/currency';
import { getRandomColor } from '../get-random-color';

export const useCurrencyField = (
  fieldId: number,
): { currencyField; isLoading: boolean } => {
  const fieldLabel = useTranslation('project.fields.currency');

  const currencyMap = useAccountCurrency();
  const isLoading = useMemo(() => currencyMap == null, [currencyMap]);

  return useMemo(
    () => ({
      currencyField: {
        fieldId,
        fieldName: 'currency',
        fieldLabel,
        type: FieldType.SingleSelect,
        optionsAvailable: true,
        customField: false,
        private: false,
        metaData: {
          options: (Object.values(currencyMap?.all ?? {}) ?? []).map(
            ({ currency }) =>
              ({
                label: getCurrencyLabel(currency),
                value: currency.currencyCode,
                active: true,
                color: getRandomColor(currency.currencyCode),
              } as FieldOptionBase<Currency['currencyCode']>),
          ),
        },
        sourceType: SourceType.Project,
      },
      isLoading,
    }),
    [currencyMap?.all, fieldId, fieldLabel, isLoading],
  );
};
